import { render } from "./ZoomDocumentView.vue?vue&type=template&id=df2ed0e0&scoped=true"
import script from "./ZoomDocumentView.vue?vue&type=script&lang=js"
export * from "./ZoomDocumentView.vue?vue&type=script&lang=js"

import "./ZoomDocumentView.vue?vue&type=style&index=0&id=df2ed0e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df2ed0e0"]])

export default __exports__